export default "__VITE_ASSET__Dxr9P7cS__"